import { createResourceCollection } from '@/request'
import { ResourceModel } from '@/request/types'
import { ID } from '@/types/model'

export type DeletedEnergySystem = {
  energy_system: ID
  profile: ID
  reason: string
} & ResourceModel

export const deletedEnergySystemsCollection =
  createResourceCollection<DeletedEnergySystem>({
    name: 'deletedEnergySystems',
    apiConfig: {
      path: 'deleted-energy-systems',
    },
    selector: (state) => state.deletedEnergySystems,
  })

export default deletedEnergySystemsCollection.slice.reducer
